module.exports = __webpack_public_path__ + "img/22.0389ad18.png";